import { resolveCosmeticAsset } from '../../profile/profile-assets.js';

/**
 * The side-decoration art inside the Settings "Live Preview" — deliberately
 * not the public hero's `ProfileSideDecoration` (that component seats art
 * against a hero's brass frame rail using geometry measured for the hero's
 * own proportions, and is hidden below `desktop:`). This preview panel has
 * no ornamental frame rail to seat against and needs to stay visible at
 * every width (smaller on mobile, per the mockup), so it is a plain
 * corner-anchored image instead.
 */
export interface PreviewSideDecorationProps {
  decorationId: string | null;
}

export function PreviewSideDecoration({ decorationId }: PreviewSideDecorationProps) {
  if (!decorationId) return null;

  return (
    <img
      src={resolveCosmeticAsset('sideDecoration', decorationId)}
      alt=""
      aria-hidden="true"
      draggable={false}
      className="pointer-events-none absolute bottom-2 right-2 z-0 max-h-14 w-auto max-w-[30%] select-none object-contain opacity-90 [filter:drop-shadow(0_2px_6px_rgb(4_31_29/0.35))] tablet:bottom-3 tablet:right-3 tablet:max-h-24"
    />
  );
}
